const initialState = {
  page: 1,
  sizePerPage: 10,
  totalRecords: 0,
  records:[],
  deleted: false,
  filters:{
    documentation:'Todos',
    major: 'Todos',
    period: '',
    belate: 'Todos',
    enroll: 'Todos',
    shifting: 'Todos',
    name: '',
    control: '',
    documentPending: 'Todos'
  }
}

export const candidatesListReducer = (state = initialState, action) => {
  switch(action.type) {
    case 'candidatesList/updateList': 
      return {
        ...state,
        ...action.payload
    }

    case 'candidatesList/setPage':
      return {
        ...state,
        page: action.page
      }

    case 'candidatesList/setSizePerPage':
      return {
        ...state,
        ...action.payload
      }

    case 'candidatesList/setFilters':
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      }
    
    case 'candidatesList/setListDeleted':
      return {
        ...state,
        deleted: action.payload
      }

    case 'candidatesList/delete':
      const students = state.records.filter( student => student.slug !== action.slug )
      return {
        ...state,
        totalRecords: students.length,
        records: [
          ...students
        ]
      }

    default:
      return state
  }
}